// GameClock.tsx — The single integrator for the shared simulation clock. Lives in
// the Canvas (needs useFrame), mirrors the player's chosen multiplier into
// gameClock.speed, and advances gameClock.time by delta*speed each frame. Every
// orbital body + the HUD calendar read gameClock, so this one component re-times
// the whole simulation when the speed changes. Renders nothing.
import { useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import { useGame } from '../state/context';
import { anchoredTime, clockAnchor, gameClock } from '../state/gameClock';
import { E2E_ENABLED } from '../e2e';

export function GameClock() {
  const { speed } = useGame();

  useEffect(() => {
    gameClock.speed = speed;
  }, [speed]);

  useFrame((_state, delta) => {
    // Server-authoritative: when a live /api/state snapshot has anchored the clock,
    // extrapolate game-time from the server's sample so the whole scene stays in sync
    // with the server economy. Under ?e2e=1 the playtest drives the clock itself
    // (freezeClock/setClockSpeed), and with no backend the anchor is dead — both fall
    // back to local integration, with the frame delta clamped so a backgrounded tab's
    // catch-up can't fling the simulation.
    if (!E2E_ENABLED && clockAnchor.live) {
      gameClock.time = anchoredTime();
      gameClock.speed = clockAnchor.speed;
      return;
    }
    gameClock.time += Math.min(delta, 0.1) * gameClock.speed;
  });

  return null;
}
